import React from 'react'

const Field = ( {label, value, className = "" } ) => {
  return (
  <div className={`danfe-field ${className}`}>
    <div className="danfe-field-label">{label}</div>
    <div className="danfe-field-value">{value || "\u00A0"}</div>
  </div>
  )
}

export default Field